import { useState, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import CloseX from 'components/icons/navigation/CloseX';
import { getCookie, setCookie } from 'utilities/cookies';
import { PRIVACY_POLICY_FEB_2026, GEOLOCATED_STATE } from 'lib/constants/cookies';

export const PrivacyPolicyBanner = () => {
  const PRIVACY_POLICY_STATES = [
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'IN',
    'IA',
    'KY',
    'MD',
    'MN',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'OR',
    'RI',
    'TN',
    'TX',
    'UT',
    'VA',
  ];

  const nodeRef = useRef(null);

  const [privacyPolicyShown, setPrivacyPolicyShown] = useState(false);

  useEffect(() => {
    const fetchGeolocation = async () => {
      let geolocationData;
      const uoomGeolocationCookie = getCookie(GEOLOCATED_STATE);

      if (uoomGeolocationCookie) {
        geolocationData = JSON.parse(uoomGeolocationCookie);
      } else {
        const response = await fetch('https://state-geolocator.homechef.com/');
        geolocationData = await response.json();
        setCookie(GEOLOCATED_STATE, JSON.stringify(geolocationData));
      }

      if (
        geolocationData?.country === 'US' &&
        PRIVACY_POLICY_STATES.includes(geolocationData?.regionCode)
      ) {
        if (!getCookie(PRIVACY_POLICY_FEB_2026)) {
          setPrivacyPolicyShown(true);
          setCookie(PRIVACY_POLICY_FEB_2026, 'true');
        }
      }
    };

    fetchGeolocation();
  }, []);

  const handleClose = () => {
    setPrivacyPolicyShown(false);
  };

  return (
    <CSSTransition
      classNames="scaleHeight"
      nodeRef={nodeRef}
      in={privacyPolicyShown}
      timeout={200}
      unmountOnExit
    >
      <div
        ref={nodeRef}
        className="text-secondary relative w-full bg-charcoal-50 py-4 pl-8 pr-12 text-left"
      >
        <p className="textXs bp1:textSm font-normal">
          To provide and personalize our offerings, make recommendations, detect and prevent fraud,
          and improve our services, we use tools that collect and record your data, and may share
          non-sensitive data with third parties, such as advertising and analytics vendors, social
          networks, technology providers and research providers. By continuing to use our websites
          and apps, this means you accept our{' '}
          <a
            href="https://www.homechef.com/terms"
            target="_blank"
            rel="noopener"
            className="text-secondary hover:text-secondary focus:text-secondary underline transition-all hover:font-semibold focus:font-semibold"
          >
            Terms
          </a>{' '}
          and our{' '}
          <a
            href="https://cook.homechef.com/privacy-policy"
            target="_blank"
            rel="noopener"
            className="text-secondary hover:text-secondary focus:text-secondary underline transition-all hover:font-semibold focus:font-semibold"
          >
            Privacy Policy
          </a>
          .
          <button
            className="pt-xs absolute bottom-0 right-0 top-0 flex appearance-none items-center border-none bg-transparent p-5 transition-all hover:text-charcoal-70 focus:text-charcoal-70"
            onClick={handleClose}
          >
            <CloseX className="h-6 w-6" />
            <span className="sr">Close this banner permanently</span>
          </button>
        </p>
      </div>
    </CSSTransition>
  );
};

export default PrivacyPolicyBanner;
